/**
 * Frontend icons are `<i class="icon-{id}">` (theme: w4d_get_icon()). The element is matched by
 * `i[class^="icon-"]`, so the icon class must stay first: swap it in place, never removeClass() + addClass().
 */
export const ICON_SELECTOR = 'i[class^="icon-"]';

export function iconHtml(id, extraClass = '') {
	return `<i class="icon-${id}${extraClass ? ` ${extraClass}` : ''}"></i>`;
}

/**
 * @param {Element|JQuery} target icon element(s)
 * @param {string} id icon id (e.g. 'check')
 */
export function swapIcon(target, id) {
	const nodes = target?.jquery ? target.get() : target instanceof Element ? [target] : [];

	nodes.forEach((node) => {
		const current = [...node.classList].find((c) => c.startsWith('icon-'));
		const next = `icon-${id}`;

		if (current === next) return;
		if (current) node.classList.replace(current, next);
		else node.classList.add(next);
	});
}
